/**
 * Service for position detail operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapPositionDetailFromTransport } from '../mappers';
import type {
  LC_GetPositionByIdOut,
  PositionDetail,
} from '../types';


export class PositionDetailService {
  async getById(positionId: number): Promise<ApiResponse<PositionDetail>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.POSITION_BY_ID(positionId);

    const response = await apiClient.get<LC_GetPositionByIdOut>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapPositionDetailFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const positionDetail = new PositionDetailService();